import{
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import Home from './Home';
import Register from './Register';
import Login from './Login';
import CreateTeam from './CreateTeam';
import decode from 'jwt-decode';
import ViewTeam from './ViewTeam';

const checkAuth=()=>{
  const  token=localStorage.getItem('token');
  const refreshToken=localStorage.getItem('refreshToken');
  try{
    decode(token);
    decode(refreshToken);

  }catch(err){
    return false;
  }
  return true;
};
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (checkAuth() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      ))}
  />
);

const index = ()=>(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact >
        <Redirect to="/view-team/"/>
      </Route>
      <Route path='/register' exact component={Register}/>
      <Route path='/login' exact component={Login}/>
      <PrivateRoute path='/view-team/:teamId?/:channelId?' exact component={ViewTeam}/>
      <PrivateRoute path='/create-team' exact component={CreateTeam}/>
      
    </Switch>
  </BrowserRouter>
);

export default index;

